import { apiFetch } from "../utils/apiClient";

/* eslint-disable no-unused-vars */
export const INDIVIDUAL_MEDICAL = 'INDIVIDUAL_MEDICAL';

const initialState = {
 individualDetails :{}
};

const medicalReducer = (state = initialState, action) => {
  switch (action.type) {
    case INDIVIDUAL_MEDICAL:
      return {
        ...state,
        individualDetails: action.payload,
      };
   
    default:
      return state;
  }
};

export default medicalReducer;

export const individualMedicalData = (data) => ({
  type: INDIVIDUAL_MEDICAL,
  payload: data,
});

export const getPolicyDetails = (policyNo) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/get-policy/${policyNo}`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getIndividualPlanOptions:', error);
      throw error;
    }
  };
};

// export const staffRegistration = (data) => {
//   return async (dispatch) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_api_url}/api/newstaff/create`,
//         {
//           method: 'POST',
//           body: JSON.stringify(data),
//           headers: { 'Content-Type': 'application/json' },
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         const errorMessage = errorData.message || 'Failed to create user';
//         throw new Error(errorMessage);
//       }
//       const val = await response.json();
//       dispatch(newStaff(val));
//       return val;
//     } catch (error) {
//       console.error('Error in staff registration:', error);

//       throw error;
//     }
//   };
// };

